// API
import { get, post } from "../../../services/api";
// Ducks
import { hideSpinner, showSpinner } from "../../../services/spinner.ducks";
import { setErrorNotification } from "../../../components/SmartNotification/SmartNotification.ducks";

const CLEAR_VOUCHERS = `CLEAR_VOUCHERS`;
const SET_VOUCHERS = `SET_VOUCHERS`;
const SET_VOUCHERS_VALIDATION = `SET_VOUCHERS_VALIDATION`;

const defaultState = {
  vouchers: [],
  voucherValidation: {}
};

export default (state = defaultState, { type, payload }) => {
  switch (type) {
    case CLEAR_VOUCHERS:
      return { ...state, ...defaultState };
    case SET_VOUCHERS:
      return { ...state, vouchers: payload };
    case SET_VOUCHERS_VALIDATION:
      return { ...state, voucherValidation: payload };

    default:
      return state;
  }
};

export const clearVouchers = () => ({
  type: SET_VOUCHERS
});

export const setVouchers = (params) => ({
  type: SET_VOUCHERS,
  payload: params
});

export const setVoucherValidation = (params) => ({
  type: SET_VOUCHERS_VALIDATION,
  payload: params
});

export const getVouchers = () => async (dispatch, getState) => {
  const {
    auth: { role }
  } = getState();
  const isAdmin = role === `admin`;

  const url = isAdmin ? `/admin/vouchers` : `/vouchers`;
  try {
    dispatch(showSpinner());
    dispatch(clearVouchers());
    const response = await dispatch(get(url));

    dispatch(setVouchers(response.data));
    dispatch(hideSpinner());
  } catch (error) {
    let message;

    if (error.response && error.response.data && error.response.data.message) {
      switch (error.response.data.message) {
        case `vouchers.get.error.candidate.notActive`:
          message = `modules.localization.register.authenticated.error.candidate.notActive`;
          break;
        case `vouchers.get.error.candidate.notFound`:
          message = `modules.localization.register.authenticated.error.candidate.notFound`;
          break;
        case `vouchers.get.error.userNotFound`:
          message = `modules.localization.register.authenticated.error.user.notFound`;
          break;

        default:
          message = `modules.localization.register.anonymous.smartNotifications.error.generic`;
          break;
      }
    }

    dispatch(
      setErrorNotification({
        messageTranslationKey: message,
        titleTranslationKey: `modules.localization.register.anonymous.smartNotifications.error.error`
      })
    );

    dispatch(hideSpinner());
  }
};

export const validateVoucher = (payload) => async (dispatch, getState) => {
  const {
    auth: { role },
    users: { selectedCandidate }
  } = getState();
  const isAdmin = role === `admin`;

  const url = isAdmin
    ? `/admin/vouchers/validation?candidateId=${selectedCandidate.id}`
    : `/vouchers/validation`;

  try {
    const response = await dispatch(post(url, payload));
    await dispatch(setVoucherValidation(response.data));
  } catch (error) {
    let message;

    if (error.response && error.response.data && error.response.data.message) {
      switch (error.response.data.message) {
        case `vouchers.validation.post.error.candidate.notActive`:
          message = `modules.localization.register.authenticated.error.candidate.notActive`;
          break;
        case `vouchers.validation.post.error.candidate.notFound`:
          message = `modules.localization.register.authenticated.error.candidate.notFound`;
          break;
        case `vouchers.validation.post.error.client.notFound`:
          message = `modules.localization.register.authenticated.error.client.notFound`;
          break;
        case `vouchers.validation.post.error.examinationPart.notFound`:
          message = `modules.localization.register.authenticated.error.examinationPart.notFound`;
          break;
        case `vouchers.validation.post.error.userDetails.notFound`:
          message = `modules.localization.register.authenticated.error.userDetails.notFound`;
          break;

        case `vouchers.validation.post.error.badRequest`:
        default:
          message = `modules.localization.register.anonymous.smartNotifications.error.generic`;
          break;
      }

      dispatch(
        setErrorNotification({
          messageTranslationKey: message,
          titleTranslationKey: `modules.localization.register.anonymous.smartNotifications.error.error`
        })
      );
    }
  }
};
